// extracted by mini-css-extract-plugin
export default {"criteriaPreview":"criteriaPreview_criteriaPreview__1Q7E-","header":"criteriaPreview_header__MYYn8","applyBtn":"criteriaPreview_applyBtn__rpENq"};